import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { COMMON_WEB_PATH, CURRENCY_SYMBOL } from "../../constant";
import BalanceContent from "./BalanceContent";
import { useNavigate, useLocation } from "react-router";
import {
  AbsoluteCenter,
  Box,
  Divider,
  Flex,
  Icon,
  Image,
  Popover,
  PopoverTrigger,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import useCheckLogin from "../../hook/useCheckLogin";

const isCredit = process.env.REACT_APP_CREDIT == 1;
const Balance = () => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { isMachineUser } = useCheckLogin();

  const linkColor = useColorModeValue("light.100", "#394367");

  const memberInfo = useSelector((state) => state.isMemberInfo);

  const { pathname } = useLocation();

  return (
    <Popover
      variant={"brandPrimary"}
      isOpen={isOpen}
      onClose={onClose}
      placement="bottom"
    >
      <Flex
        // bgImage={{
        //   base: `url('${COMMON_WEB_PATH}/now888/header/point_banner.png')`,
        //   md: `url('${COMMON_WEB_PATH}/now888/header/point_banner.png')`,
        // }}
        bgImage="linear(to-b,#231D23,#5C4F5E)"
        borderRadius={"30px"}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100%100%"
        boxShadow={"inset 0px 0px 5px black"}
        borderBottom="2px solid #DCCFC6"
        pl={{
          base: "40px",
          md: isMachineUser ? "70px" : "70px",
        }}
        pr={{
          base: "10px",
          md: "40px",
        }}
        pb={{
          base: "0px",
          md: "0px",
        }}
        alignItems="center"
        gap="10px"
        minW={{
          base: "150px",
          //md: "180px",
          md: isMachineUser ? "175px" : "180px",
          xl: isMachineUser ? "245px" : "180px",
        }}
        maxW={{
          base: "200px",
          md: "250px",
          xl: "300px",
        }}
        height={{
          base: "35px",
          md: isMachineUser ? "50px" : "50px",
          //xl: "90px",
          xl: isMachineUser ? "50px" : "50px",
        }}
        // cursor="pointer"
        position="relative"
        // mb={{
        //   sm: "10px",
        // }}

        justifyContent={"center"}
      >
        {/* ｃｒｅｄｉｔ字卡title */}
        {/* <AbsoluteCenter
          display={{
            base: "none",
            md: "block",
          }}
          //w="90px"
          w={isMachineUser ? "110px" : "90px"}
          //top="18px"
          top={isMachineUser ? "5px" : "5px"}
        >
          <Image
            src={`${COMMON_WEB_PATH}/5285/header/point_credit_title_blue.png`}
          />
        </AbsoluteCenter> */}
        {/* 硬幣ICON */}
        <AbsoluteCenter
          display={{
            base: "block",
            md: "block",
          }}
          position="absolute"
          left={{
            base: "20px",
            md: "30px",
          }}
          w={{
            base: "40px",
            md: "60px",
          }}
          h={{
            base: "40px",
            md: "60px",
          }}
        >
          <Image src={`${COMMON_WEB_PATH}/theOne/header/balance_icon.png`} />
        </AbsoluteCenter>
        <Flex w="100%" direction={`column`} alignItems={`center`}>
          <Box
            onClick={() => {
              if (pathname.includes("gamebox")) {
                return;
              } else {
                if (isCredit) {
                  return;
                }
                onToggle();
              }
            }}
            display={`flex`}
            alignItems={`center`}
            w="100%"
            gap="5px"
            overflowX="scroll"
            // mb="10px"
          >
            <BalanceContent
              // hiddenSymbol
              hiddenSymbol
              balanceStyle={{
                fontSize: {
                  base: "16px",
                  md: "24px",
                  lg: "27px",
                  xl: isMachineUser ? "30px" : "30px",
                },
                fontWeight: "700",
                color: "white",
              }}
            />
          </Box>
        </Flex>
      </Flex>
      {/* <WalletList onClose={onClose} /> */}
    </Popover>
  );
};

export default Balance;
